import angular from 'angular';
import { NameSelectorComponent } from './name-selector.component';
import { NewNameModalComponent } from './new-name-modal';
import { SuffixSelectModule } from '../../directives/suffix-select';

export const NameSelectorModule = angular
  .module('app.directives.name-selector', [SuffixSelectModule.name])
  .component('updNameSelector', NameSelectorComponent)
  .component('updNewNameModal', NewNameModalComponent);
